/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import formattingRulesParameters from '@jira/business__shared-components-conditional-formatting-sidebar/src/ui/format-rules/__generated__/FormatRulesQuery$parameters';
import type { FormatRulesQuery } from '@jira/business__shared-components-conditional-formatting-sidebar/src/ui/format-rules/__generated__/FormatRulesQuery.graphql';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraSoftwareListAppQuery$parameters.ts';
import type { JiraSoftwareListAppQuery } from './__generated__/JiraSoftwareListAppQuery.graphql.ts';

const FORMAT_RULES_FIRST = 20;

type ListEntryPointComponent = EntryPointComponent<
	{
		listQuery: JiraSoftwareListAppQuery;
		formattingRulesQuery: FormatRulesQuery;
	},
	{},
	{},
	{}
>;

export const listEntryPoint: EntryPoint<ListEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<ListEntryPointComponent>(
			/* webpackChunkName: "async-software-list-entrypoint" */ './JiraSoftwareListApp.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
			const projectKey = context.match.params.projectKey;

			if (projectKey == null) {
				throw new Error('Project key missing');
			}

			return {
				queries: {
					listQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId,
							projectKey,
						},
					},
					formattingRulesQuery: {
						parameters: formattingRulesParameters,
						variables: {
							projectKey,
							cloudId,
							first: FORMAT_RULES_FIRST,
						},
						options: {
							fetchPolicy: 'network-only' as const,
						},
					},
				},
			};
		},
	});
